/**
 *  Quantity Button Fix
 */
jQuery(document).ready(function($) {

	$(document).on('click', '.qty-button', function(e) {
		e.preventDefault();
		let $this = $(this);
		let input = $this.siblings('input.qty');
		let qty = input.val();

		if ( $this.hasClass('plus') ) {
			qty ++;
		}
		else {
			qty --;
		}

		if ( qty < 1 ) {
			qty = 1;
		}

		input.val(qty);

		if ( $('body').hasClass('woocommerce-cart') ) {
			input.trigger('change');
		}
	});
});